/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChevronsDownRight = createReactComponent(
  "chevrons-down-right",
  "IconChevronsDownRight",
  [
    ["path", { d: "M13 5v8h-8", key: "svg-0" }],
    ["path", { d: "M17 9v8h-8", key: "svg-1" }]
  ]
);

export { IconChevronsDownRight as default };
//# sourceMappingURL=IconChevronsDownRight.js.map
